import { Body } from './body';
import { Header } from './header';
import { Wrapper } from './wrapper';

export interface PaymentProcessingProps {
  percentage: number;
  wweLogo: string;
  successLogo: string;
  onClose?: () => void;
}

export function PaymentProcessing({
  percentage,
  wweLogo,
}: {
  percentage: number;
  wweLogo: string;
}): React.JSX.Element {
  return (
    <Wrapper>
      <Header title="Payment is processing" />
      <Body percentage={percentage} wweLogo={wweLogo} />
    </Wrapper>
  );
}
